// extracted by mini-css-extract-plugin
export default {"services":"HRTPage_services__zxeYp","contactUs":"HRTPage_contactUs__bxNnC"};